import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Card } from '@uhg-abyss/web/ui/Card';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { event as TaggingEvent } from '@uhg-abyss/web/tools/event';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

const Value = styled('div', {
  color: '$gray8',
  fontSize: '16px',
  lineHeight: '22px',
  fontWeight: 700,
  fontStyle: 'normal',
  marginTop: '2.3%',
  wordWrap: 'break-word',
});

const Name = styled('div', {
  color: 'rgb(51, 51, 51)',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '22px',
});

export const W9Upload = () => {
  const router = useRouter();
  const form = useForm();
  const location = useLocation();
  const isFinalStep = location.pathname.includes('/step/4');

  const w9form = form.getValues('w9form');

  const adobeTagging = () => {
    const interactionName = 'w9 details widget';
    const interactionValue = 'edit w9 details';
    TaggingEvent('ATTESTATION_PAGE_EDIT', {
      interactionName,
      interactionValue,
    });
  };
  const skeleton = (data, contentRenderer) => {
    return w9form ? (
      contentRenderer(data)
    ) : (
      <Skeleton variant="rounded" height={20} width={200}>
        {contentRenderer('-')}
      </Skeleton>
    );
  };

  const jumpLinks = (navigateTo) => {
    adobeTagging();
    const eventData = {
      action: 'EditDetails',
    };
    TaggingEvent('EAPM_TRANSACTION_CONTINUE', eventData);
    router.navigate(navigateTo);
  };

  return (
    <Card
      header={
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          W-9 Details
          {isFinalStep && (
            <div id="w9-edit">
              <Button
                before={
                  <IconSymbol
                    icon="edit"
                    size="20px"
                    css={{ marginRight: '-10px' }}
                  />
                }
                id="attestation-w9-details-edit-details"
                onClick={() => {
                  return jumpLinks('/tin-registration/step/1');
                }}
                variant="tertiary"
                css={{ padding: '0px' }}
              >
                Edit Details
              </Button>
            </div>
          )}
        </div>
      }
    >
      <Card.Section>
        <Layout.Stack alignItems="left">
          <div>
            <Name id="attestation-w9-name">
              Name (As shown on your income tax return)
            </Name>
            <Value id="attestation-w9-name-value">
              {skeleton(w9form && w9form.name, (data) => {
                return data || '-';
              })}
            </Value>
          </div>
          <div>
            <Name id="attestation-w9-business-name">
              Business Name/Disregarded Entity Name
            </Name>
            <Value id="attestation-w9-business-name-value">
              {skeleton(w9form && w9form.businessName, (data) => {
                return data || '-';
              })}
            </Value>
          </div>
          <div>
            <Name id="attestation-w9-fedral-tax-classification">
              Federal Tax Classification
            </Name>
            <Value id="attestation-w9-fedral-tax-classification-value">
              {skeleton(w9form && w9form.federalTaxClassification, (data) => {
                return data || '-';
              })}
            </Value>
          </div>
          <div>
            <Name id="attestation-w9-w9Form">W-9 Form</Name>
            <div
              style={{
                fontWeight: 700,
                color: isFinalStep ? 'rgb(25, 110, 207)' : 'rgb(51,51,51)',
              }}
            >
              {skeleton(
                w9form && w9form.fileName && w9form.fileName.name,
                (data) => {
                  return data || '-';
                }
              )}
            </div>
          </div>
        </Layout.Stack>
      </Card.Section>
    </Card>
  );
};

W9Upload.propTypes = {};
